import { persistStateTypes } from 'a/reducers/persistStateReducer';
import { GAME_ID } from '../data/goblinGourmetConstants';

const savedDataReducer = (state = {}, { type, gameId, stateData }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const { GameData: savedData } = stateData[GAME_ID];
      if (savedData !== null && savedData !== undefined) {
        return {
          ...state,
          ...savedData.gameDetails,
        };
      }
      return state;
    }

    default:
      return state;
  }
};

export default savedDataReducer;
